import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { confirmPasswordReset, getAuth } from "firebase/auth";
import { toast } from "sonner"; 

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode"); 
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); 
  // const navigate = useNavigate();

  const handleReset = async () => {
    if (!newPassword) {
      toast.error("⚠️ Please enter a new password");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("⚠️ Password must be at least 6 characters long");
      return;
    }

    const auth = getAuth();
    setLoading(true);

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
       setSuccess(true);
       
    } catch (err) {
      console.error("Reset error:", err);

      if (err.code === "auth/expired-action-code") {
        toast.error("❌ This password reset link has expired. Please request a new one.");
      } else if (err.code === "auth/invalid-action-code") {
        toast.error("❌ This password reset link is invalid or already used.");
      } else {
        toast.error(`❌ ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-green-50">
        <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8 text-center">
          <h2 className="text-2xl font-bold text-green-600 mb-4">
            ✅ Password Reset Successful!
          </h2>
          <p className="text-gray-700 mb-6">
            Your password has been updated. You can now log in with your new password.
          </p>
          {/* <button
            onClick={() => navigate("/login")}
            className="w-full py-2 rounded-lg font-semibold bg-blue-600 text-white hover:bg-blue-700 transition duration-200"
          >
            Go to Login
          </button> */}
        </div>
      </div>
    );
  }

  // ✅ Default reset form
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Reset Password
        </h2>

        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full px-4 py-2 mb-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        <button
          onClick={handleReset}
          disabled={loading}
          className={`w-full py-2 rounded-lg font-semibold transition duration-200 ${
            loading
              ? "bg-red-500 cursor-not-allowed"
              : "bg-red-600 text-white hover:bg-red-700"
          }`}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
